import { composeIO } from 'react-compose-io'
import { fieldsConcatenarIO } from './FieldsConcatenar.IO'
import { FieldsConcatenarView } from './FieldsConcatenar.View'

export const FieldsConcatenar = composeIO(FieldsConcatenarView, fieldsConcatenarIO)
